import { render, staticRenderFns } from "./customsRegister.vue?vue&type=template&id=4916f292&scoped=true"
import script from "./customsRegister.vue?vue&type=script&lang=js"
export * from "./customsRegister.vue?vue&type=script&lang=js"
import style0 from "./customsRegister.vue?vue&type=style&index=0&id=4916f292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4916f292",
  null
  
)

export default component.exports